import { userConstants, globalConstants } from "../../constants";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../constants/toast.constants";
import { userService } from "../../services";
import { customToast } from "../../shared/utility";
import { custom, success } from "./utilities";

const { USER_PROFILE, USER_FEEDBACK } = userConstants;

const getUserProfile = (id) => (dispatch) => {
  dispatch(custom(USER_PROFILE, globalConstants.SPINNER_ACTIVATE));
  userService
    .getUserProfile(id)
    .then(
      (response) => {
        dispatch(success(response.data, USER_PROFILE));
      },
      (error) => customToast(error[0], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(custom(USER_PROFILE, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateUserProfile = (data, successFunction) => (dispatch) => {
  dispatch(custom(USER_PROFILE, globalConstants.SPINNER_ACTIVATE));
  userService
    .updateUserProfile(data)
    .then(
      (response) => {
        successFunction(response.data);
        if (!response.data?.needsConfirmation) {
          customToast(response.msg, SUCCESS_TOAST);
          dispatch(success(response.data, USER_PROFILE));
        }
      },
      (error) => customToast(error[0] ?? error[1][0], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(custom(USER_PROFILE, globalConstants.SPINNER_DIACTIVATE))
    );
};

const sendFeedback = (data, onSuccess) => (dispatch) => {
  dispatch(custom(USER_FEEDBACK, globalConstants.SPINNER_ACTIVATE));
  userService
    .sendFeedback(data)
    .then(
      (response) => {
        onSuccess();
        customToast(response.msg, SUCCESS_TOAST);
      },
      (error) => customToast(error[0], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(custom(USER_FEEDBACK, globalConstants.SPINNER_DIACTIVATE))
    );
};

export const userActions = {
  sendFeedback,
  getUserProfile,
  updateUserProfile,
};
